<div class="w-full p-4 md:p-12" *transloco="let t; prefix: 'userPage'">
    <div class="text-title text-quaternary mb-4">{{t('userInfo')}}</div>
    <div class="mb-2 md:w-[300px]">
        <std-input customInputClass="custom-input" customLabel="label-input"
            customContainerlass="opacity-50 pointer-events-none" labelPosition="top" [label]="t('name')"
            [(ngModel)]="userInfo.firstName"
            customLabel="text-quaternary text-medium"></std-input>
    </div>
    <div class="mb-2 md:w-[300px]">
        <std-input customInputClass="custom-input" customLabel="label-input"
            customContainerlass="opacity-50 pointer-events-none" labelPosition="top" [label]="t('surname')"
            [(ngModel)]="userInfo.lastName"
            customLabel="text-quaternary text-medium"></std-input>
    </div>
    <div class="mb-2 md:w-[300px]">
        <std-input customInputClass="custom-input" customLabel="label-input"
            customContainerlass="opacity-50 pointer-events-none" labelPosition="top" [label]="t('email')"
            [(ngModel)]="userInfo.email"
            customLabel="text-quaternary text-medium"></std-input>
    </div>
    <div class="text-title text-quaternary mb-4">{{t('preference')}}</div>
    <div class="grid gap-4">
        <div class="mb-2 md:w-[300px]">
            <div class="text-quaternary text-medium select-none mb-2">{{t('changeZoom')}}</div>
            <std-select customLabel="label-input"
                customClassContainerElement="max-h-[250px] overflow-y-scroll custom-scrollbar"
                (onChangeValue)="changeZoom($event)" customClassContaier="w-60 mr-4 border-primary"
                [data]="zoomAvailable" [currentValue]="currentZoom"></std-select>
        </div>
        <div class="md:w-[300px]">
            <div class="text-quaternary text-medium select-none mb-2">{{t('invertColors')}}</div>
            <std-toggle [id]="'toggle-theme'" (onValueChange)="invert($event)" [checked]="invertColors"></std-toggle>
        </div>
        <div class="md:w-[300px]">
            <div class="text-quaternary text-medium select-none mb-2">{{t('changeColors')}}</div>
            <!-- <std-select (onChangeValue)="changeColors($event)" customClassContaier="w-60 mr-4" [data]="accessibilityThemes"
                [currentValue]="currentAccebilityTheme"></std-select> -->
                <std-slider [min]="100" [max]="300" [step]="1" [value]="currentContrast" id="contrast-slider" (onValueChange)="changeColors($event)"></std-slider>
        </div>
        <!-- <div class="md:w-[300px]">
            <div class="text-quaternary text-medium select-none mb-2">{{t('darkMode')}}</div>
            <std-toggle [id]="'toggle-theme'" (onValueChange)="changeTheme()" [checked]="darkMode"></std-toggle>
        </div> -->
        <!-- <div class="md:w-[300px]">
            <div class="text-quaternary text-medium select-none mb-2">{{t('changeLanguage')}}</div><std-select
                customLabel="label-input" customClassContainerElement="max-h-[250px] overflow-y-scroll custom-scrollbar"
                customClassContaier="w-60 mr-4 border-primary" (onChangeValue)="changeLanguage($event)"
                [data]="languages" [currentValue]="currentLanguage"></std-select>
        </div> -->
    </div>
    <div class="w-[30%] mt-[30px]"><std-button (click)="showModalChangePassword = true"
            buttonClass="bg-primary text-white hover:bg-primary focus:bg-primary">CAMBIA PASSWORD</std-button></div>
    <div class="w-[30%] mt-[30px]"><std-button (click)="logout()"
            buttonClass="bg-primary text-white hover:bg-primary focus:bg-primary">LOGOUT</std-button></div>
</div>


@if(showModalChangePassword){<std-modal cardClass="!max-w-[90vw]" [show]="showModalChangePassword"
    [closeOnOutside]="false" headerClass="bg-primary" (close)="showModalChangePassword = false">
    <div header class="text-white">Cambia password</div>
    <div content class="w-[400px] gap-4 grid">
        <div class="mb-2">
            <std-input customInputClass="custom-input" customLabel="label-input" labelPosition="top"
                [label]="'Vecchia password'" placeholder="Vecchia password" [(ngModel)]="dataPassword.oldPassword"
                customLabel="text-quaternary text-medium"></std-input>
        </div>
        <div class="mb-2">
            <std-input customInputClass="custom-input" customLabel="label-input" labelPosition="top"
                [label]="'Nuova password'" placeholder="Nuova password" [(ngModel)]="dataPassword.newPassword"
                customLabel="text-quaternary text-medium"></std-input>
        </div>
        <div class="mb-2">
            <std-input customInputClass="custom-input" customLabel="label-input" labelPosition="top"
                [label]="'Conferma nuova password'" placeholder="Conferma nuova password"
                [(ngModel)]="dataPassword.newPasswordConfirm"
                customLabel="text-quaternary text-medium"></std-input>
        </div>
        <div class="w-full flex" *transloco="let t">
            <std-button class="w-[48%]  mr-[4%] " (click)="changePassword()" size="sm"
                buttonClass="bg-primary text-white hover:bg-primary focus:bg-primary">Conferma</std-button>
            <std-button class="w-[48%]" (click)="showModalChangePassword=false "
                buttonClass="bg-primary text-white hover:bg-primary focus:bg-primary" size="sm">Annulla</std-button>
        </div>
    </div>
</std-modal>}